import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { InputText } from 'triider-components';
import iconEmail from 'assets/img/email-icon.svg';
import { validateUserFields } from 'utils/userValidation';
import { routes } from 'config/routes';
import Header from 'components/Header';

import { Creators as AuthCreators } from 'store/ducks/auth';
import { Creators as UiCreators } from 'store/ducks/ui';

import {
  Container, BoxLogin, StyledLink, StyledButtonTriider,
} from './styles';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      errors: {},
    };

    this.setFields = this.setFields.bind(this);
    this.validateField = this.validateField.bind(this);
    this.login = this.login.bind(this);
  }

  setFields({ target }) {
    const { name, value } = target;

    this.setState({ [name]: value });
  }

  validateField({ target }) {
    const { name, value } = target;

    const message = validateUserFields(name, value);

    const { errors: oldErrors } = this.state;

    const errors = {
      ...oldErrors,
      [name]: message,
    };

    this.setState({ errors });
  }

  login(e) {
    e.preventDefault();

    const { email, password } = this.state;

    const errors = {
      email: validateUserFields('email', email),
      password: validateUserFields('password', password),
    };

    if (!Object.values(errors).some(e => !!e)) {
      const { _loginRequest } = this.props;
      _loginRequest({ email, password });
    } else {
      this.setState({ errors });
    }
  }

  render() {
    const { email, password, errors } = this.state;
    const { isLoading } = this.props;

    const buttonDisabled = !email || !password || Object.values(errors).some(e => !!e);

    return (
      <React.Fragment>
        <Helmet title="Triider - Entrar" />
        <Header />
        <form onSubmit={this.login}>
          <Container>
            <BoxLogin>
              <h1>Login</h1>
              <InputText
                placeholder="E-mail:"
                type="email"
                name="email"
                value={email}
                error={errors.email}
                onChange={this.setFields}
                onBlur={this.validateField}
                iconRight={iconEmail}
              />

              <InputText
                placeholder="Senha:"
                type="password"
                name="password"
                value={password}
                error={errors.password}
                onChange={this.setFields}
                onBlur={this.validateField}
              />

              <StyledLink to={routes.recovery}>Esqueci minha Senha</StyledLink>

              <StyledButtonTriider
                type="submit"
                size="fullBlock"
                disabled={buttonDisabled}
                isLoading={isLoading}
              >
                Entrar
              </StyledButtonTriider>
            </BoxLogin>
          </Container>
        </form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.ui.loaders.includes('AUTH'),
});

const mapDispatchToProps = {
  _loginRequest: AuthCreators.loginRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
